<template>
  <div
    v-if="investigations"
    class="subdomain-wrapper"
    :style="{
      backgroundColor: currentSubdomain
        ? currentSubdomain.acf.background_colour
        : 'white',
    }"
  >
    <div
      class="z2 fixed center pointer-events-none top-0 flex items-center w-full -mt-1"
    >
      <div id="subdomain-logo" class="caps text-xs">
        <span class="fa px2 py-1">FA</span>
        <span class="subdomain px2">{{ currentSubdomain.title.rendered }}</span>
      </div>
    </div>

    <!-- <scrollactive class="z4 investigation&#45;nav xs&#45;hide" ref="navbar"> -->
    <!-- <ul class="col&#45;12 menu&#45;items caps list&#45;reset max&#45;width mx&#45;auto center hide&#45;print"> -->
    <!--   <li class="mx2"> -->
    <!--     <a class="scrollactive&#45;item is&#45;active" v&#45;scroll&#45;to="'#about'">About</a></li> -->
    <!--   <li class="mx2"> -->
    <!--     <a class="scrollactive&#45;item is&#45;active" v&#45;scroll&#45;to="'#projects'">Projects</a></li> -->
    <!-- </ul> -->
    <!-- </scrollactive> -->

    <div class="content lazy-container pt-24">
      <div
        id="about"
        class="block-wrapper"
        v-if="currentSubdomain"
        v-html="currentSubdomain.content.rendered"
      />
    </div>

    <div id="projects">
      <div class="sm-mx2 flex flex-wrap lazy-container">
        <router-link
          v-for="(content, index) in subdomainContent"
          v-if="content"
          class="sm-col-12 lg-col-6 mb0 sm-mb3 md-mb3 lg-mb3"
          :to="
            isExhibition(content)
              ? { name: 'Exhibition', params: { slug: content.slug } }
              : {
                  name: 'Investigation',
                  params: { investigationSlug: content.slug },
                }
          "
          :key="content.id"
        >
          <!-- STUDIES -->
          <div v-if="isStudy(content)" class="investigation hover-toggle">
            <div class="m2">
              <h2 class="investigation-title relative flex flex-auto">
                <div class="flex-auto">
                  <span class="red caps fs-s">study&nbsp;&nbsp;</span>
                  <span
                    class="caps"
                    v-html="preventWidows(content.title)"
                  ></span>
                </div>
              </h2>

              <div
                v-if="
                  content.hasOwnProperty('feature_image') &&
                  content.feature_image
                "
                class="video-wrapper relative"
              >
                <img
                  class="preview-image video-fallback-image"
                  :width="content.feature_image.width"
                  :height="content.feature_image.height"
                  :data-src="content.feature_image.link"
                  :data-srcset="content.feature_image.srcset"
                />
              </div>

              <div
                v-else-if="content.preview_image"
                class="preview-placeholder video-wrapper"
              >
                <img
                  class="preview-image video-fallback-image"
                  :width="content.preview_image.width"
                  :height="content.preview_image.height"
                  :data-src="content.preview_image.link"
                />
              </div>

              <div v-else class="aspect-video bg-gray-200 w-full h-auto" />

              <div class="card relative border">
                <div class="card-row-upper row clearfix flex">
                  <card-block
                    width="30"
                    header="Date"
                    class="tabular"
                    :content="incidentDates(content)"
                  >
                  </card-block>

                  <card-block
                    width="70"
                    type="no-header"
                    header=""
                    :content="clearNewLines(content.abstract)"
                  >
                  </card-block>
                </div>
              </div>
            </div>
          </div>
          <!-- EXHIBITIONS -->
          <div
            v-else-if="isExhibition(content)"
            class="investigation hover-toggle"
          >
            <div class="m2">
              <h2 class="exhibition-title">
                <span class="red fs-s"
                  >Exh.<span v-text="content.code"></span>&nbsp;</span
                >
                <span class="caps" v-html="preventWidows(content.title)"></span>
              </h2>
              <div>
                <div class="exhibition-thumbnail relative">
                  <img
                    :data-src="getPreviewImageFile(content)"
                    :alt="content.title"
                  />
                </div>
              </div>

              <div class="card relative border">
                <router-link
                  :to="{ name: 'Exhibition', params: { slug: content.slug } }"
                >
                  <div class="row card-row clearfix flex">
                    <card-block
                      width="30"
                      header="Date"
                      :content="
                        exhibitionStatus(content) + exhibitionDates(content)
                      "
                    >
                    </card-block>
                    <card-block
                      width="70"
                      header="Venue"
                      :content="content.venue"
                    >
                    </card-block>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <!-- INVESTIGATIONS -->
          <div
            v-else
            class="investigation hover-toggle"
            v-hover-intent:150="playVideo.bind(null, index)"
            @mouseleave.stop="pauseVideo(index)"
          >
            <div class="m2">
              <h2 class="investigation-title relative flex flex-auto">
                <div class="flex-auto">
                  <span class="red fs-s"
                    >I.<span v-text="content.code"></span>&nbsp;&nbsp;</span
                  >
                  <span
                    class="caps"
                    v-html="preventWidows(content.title)"
                  ></span>
                  <span
                    v-if="content.fo_status === 'by_fo'"
                    class="fo-badge red caps fs-xs"
                  >
                    Forensic&nbsp;Oceanography
                  </span>
                  <span
                    v-else-if="content.fo_status === 'with_fo'"
                    class="fo-badge red caps fs-xs"
                  >
                    With&nbsp;Forensic&nbsp;Oceanography
                  </span>
                </div>
              </h2>

              <div v-if="showVideo(content)" class="video-wrapper relative">
                <video
                  class="absolute xs-hide sm-hide md-hide touch-hide"
                  :data-src="content.preview_video.link"
                  :ref="'preview-video-' + index"
                  muted
                  preload="auto"
                />

                <img
                  class="video-fallback-image touch-show"
                  :alt="`${content.title}`"
                  :data-src="content.preview_image.link"
                />

                <div class="video-color absolute"></div>
              </div>

              <div
                v-else-if="content.hasOwnProperty('feature_image')"
                class="video-wrapper relative"
              >
                <img
                  class="preview-image video-fallback-image absolute"
                  :width="content.feature_image.width"
                  :height="content.feature_image.height"
                  :data-src="content.feature_image.link"
                />
              </div>

              <div v-else class="preview-placeholder video-wrapper">
                <img
                  class="preview-image video-fallback-image"
                  :width="content.preview_image.width"
                  :height="content.preview_image.height"
                  :data-src="content.preview_image.link"
                />
              </div>

              <div class="card relative border">
                <div class="card-row-upper row clearfix flex">
                  <card-block
                    width="30"
                    header="Date"
                    class="tabular"
                    :content="incidentDates(content)"
                  >
                  </card-block>

                  <card-block
                    width="70"
                    type="no-header"
                    header=""
                    :content="clearNewLines(content.abstract)"
                  >
                  </card-block>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div
      id="methodology-description"
      class="fs-s z1 p2 border col-8 sm-col-5 lg-col-4"
      v-if="this.$route.name === 'Investigation Methodology'"
      :class="{ open: methodologyOpen }"
      @click="methodologyOpen = !methodologyOpen"
    >
      <h3 class="caps m0 flex justify-between">
        <span v-html="currentMethodology.title.rendered"></span>
        <span>⤵</span>
      </h3>
      <div class="relative">
        <div
          class="description"
          v-html="currentMethodology.acf.description"
        ></div>
        <div class="description-gradient col-12 absolute"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState, mapActions } from "vuex";
import {
  commissionedBy,
  commissionedByHeading,
  incidentDates,
  formatDate,
  getPreviewVideoFile,
  getPreviewImageFile,
  getPreviewImageStyle,
  exhibitionCategory,
  exhibitionDates,
  exhibitionStatus,
  isStudy,
  isExhibition,
} from "@/utils";
import SubMenu from "@/components/SubMenu";
import ExhibitionBlocks from "@/components/ExhibitionBlocks";
import CardBlock from "@/components/CardBlock";

export default {
  name: "Subdomain",

  data() {
    return {
      methodologyOpen: false,
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img",
      }),
    };
  },

  metaInfo() {
    let title = "Subdomain";
    if (this.$route.name === "Subdomain") {
      title = `${this.unSlug(this.$route.params.subdomain)}`;
    }

    // TODO: Oh no, it's not functional
    title = this.titleCase(title);

    return {
      title: title,
      meta: [
        { name: "og:title", content: title },
        { name: "twitter:title", content: title },
        { name: "og:image", content: "/fa-share-lg.png" },
        { name: "twitter:image", content: "/fa-share-lg.png" },
        {
          name: "og:url",
          content: `${window.location.origin}/${this.$route.fullPath}`,
        },
        { name: "og:type", content: "website" },
        { name: "og:description", content: this.siteDescription() },
      ],
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      this.lazyContainer.update();
    });
    window.onresize = debounce(() => {
      this.equalizeHeights();
    }, 100);
  },

  components: {
    CardBlock,
    SubMenu,
    ExhibitionBlocks,
  },

  computed: {
    ...mapState([
      "exhibitions",
      "investigations",
      "methodologies",
      "subdomains",
    ]),
    currentSubdomain() {
      const domain = this.subdomains.filter((x) => {
        return x.slug === this.$route.params.subdomain;
      });
      if (domain.length == 1) {
        return domain[0];
      } else {
        return null;
      }
    },
    allInvestigations() {
      return this.$store.getters.allInvestigations;
    },
    subdomainContent() {
      return this.currentSubdomain.acf.related.map((x) => {
        if (x.post_type === "investigation") {
          return this.allInvestigations[this.investigationId(x)];
        } else {
          // exhibition
          return this.exhibitions[this.exhibitionId(x)];
        }
      });
    },
    currentMethodology() {
      return this.methodologies.find((x) => x.slug === this.$route.params.slug);
    },
  },

  methods: {
    ...mapActions(["setShowInvestigationSubSectionText"]),
    isStudy,
    isExhibition,
    commissionedBy,
    commissionedByHeading,
    incidentDates,
    formatDate,
    getPreviewVideoFile,
    getPreviewImageFile,
    getPreviewImageStyle,
    exhibitionCategory,
    exhibitionDates,
    exhibitionStatus,
    investigationId(x) {
      return this.$store.getters.allInvestigations
        .map((x) => x.id)
        .indexOf(x.ID);
    },
    exhibitionId(x) {
      return this.exhibitions.map((x) => x.id).indexOf(x.ID);
    },
    updateShowInvestigationSubSectionText({ going }) {
      if (going === "out") {
        this.setShowInvestigationSubSectionText(true);
      } else {
        this.setShowInvestigationSubSectionText(false);
      }
    },
    showVideo(investigation) {
      return !this.isMobileWidth() && investigation.preview_video;
    },
    playVideo(index) {
      if (`preview-video-${index[0]}` in this.$refs) {
        let el = this.$refs["preview-video-" + index][0];
        if (!el.hasAttribute("src")) {
          el.setAttribute("src", el.getAttribute("data-src"));
        }
        this.$refs["preview-video-" + index][0].play();
      }
    },
    pauseVideo(index) {
      if (`preview-video-${index[0]}` in this.$refs) {
        this.$refs["preview-video-" + index][0].pause();
      }
    },
    equalizeHeights() {
      let items = Array.prototype.slice
        .call(document.querySelectorAll(".investigation"))
        .reduce(function (result, value, index, array) {
          if (index % 2 === 0) result.push(array.slice(index, index + 2));
          return result;
        }, []);

      let classes = [
        ".investigation-title",
        ".card-row-upper",
        ".card-row-lower",
      ];

      items.map((x) => {
        if (x.length === 2) {
          classes.map((className) => {
            let a = x[0].querySelector(className);
            let b = x[1].querySelector(className);
            a.removeAttribute("style");
            b.removeAttribute("style");
            let maxHeight = Math.max.apply(Math, [
              a.clientHeight,
              b.clientHeight,
            ]);
            a.style.height = maxHeight + "px";
            b.style.height = maxHeight + "px";
          });
        }
      });
    },
    // TODO: DUPE DRY UP
    updateLazy() {
      this.$nextTick(function () {
        this.lazyContainer.update();
      });
    },
  },
  watch: {
    investigations() {
      this.$nextTick(function () {
        // this.equalizeHeights()
        this.updateLazy();
      });
    },
    $route() {
      this.$nextTick(function () {
        this.updateLazy();
      });
    },
    currentSubdomain: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.acf.background_colour) {
          this.$store.commit(
            "SET_SUBDOMAIN_BG_COLOR",
            newVal.acf.background_colour
          );
        } else {
          this.$store.commit("SET_SUBDOMAIN_BG_COLOR", null);
        }
      },
    },
  },
};
</script>

<style lang="css" scoped>
#subdomain-logo {
  display: inline-block;
  margin: 1em auto;
  border: 2px solid var(--red);
  color: var(--red);
  .fa {
    background: var(--red);
    color: white;
  }
  span {
    display: inline-block;
  }
}
#projects {
  margin-top: 6em;
  margin-bottom: 10em;
}
.video-wrapper {
  padding-top: 25px;
  width: 100%;
  padding-top: 56.1%;
  background: var(--load-bg);
  overflow: hidden;
}
.investigation {
  &:hover {
    h2.investigation-title {
      color: var(--red);
    }
    img,
    video {
      filter: brightness(100%) contrast(100%);
      opacity: 1;
    }
  }
}

.abstract {
  display: none;
  background: var(--col-light);
  top: 0;
  left: 30%;
  width: calc(70% - var(--space-2) * 2);
  height: calc(100% - var(--space-2));
}

video,
img {
  top: 0;
  /*opacity: 0.2;*/
  transition: filter 0.3s ease-out;
  filter: brightness(110%) contrast(80%);
  width: 100%;
}

video {
  z-index: 1;
}

img {
  object-fit: cover;
  height: 100%;
}

.video-color {
  top: 0;
  width: 100%;
  height: 98.5%;
  background: var(--col-light);
  mix-blend-mode: multiply;
}

.video-fallback-image {
  /* object-fit: fill; */
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  /* TODO: Slightly jank fix for tiny height discrepancy between fallback and vid */
  height: calc(100% + 1px);
}

.preview-placeholder {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;

  img {
    position: absolute;
    object-fit: cover;
    top: 0;
  }
}

.preview-image + .card {
  margin-top: -0.3em;
}

.fo-badge {
  padding-left: 0.5em;
}

.exhibition-thumbnail {
  line-height: 0;
  height: 26.7vw;
  overflow: hidden;
  /* min-height: 636px; */
}

#methodology-description {
  max-width: 600px;
  border-radius: 12px;
  position: fixed;
  bottom: 1em;
  right: 1em;
  opacity: 0.8;
  background-color: var(--red);
  color: var(--col-light);
  transition: all 0.3s ease-out;
  cursor: pointer;

  .description {
    -webkit-overflow-scrolling: touch;
    max-height: 4.5em;
    overflow: hidden;
    transition: all 0.3s ease-out;

    >>> p:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
    }

    >>> a {
      color: var(--col-light);
      text-decoration: underline;
    }
  }

  .description-gradient {
    pointer-events: none;
    transition: all 0.3s ease-out;
    height: 2em;
    margin-top: -2em;
    background-image: linear-gradient(
      to bottom,
      rgba(var(--red-val), 0),
      rgba(var(--red-val), 1)
    );
  }

  &.open {
    opacity: 1;

    .description {
      overflow-y: scroll;
      max-height: 50vh;
    }
    .description-gradient {
      opacity: 0;
    }
  }
}

@media (--phone) {
  #investigations {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
